import { render, staticRenderFns } from "./AnnualReviewDetail.vue?vue&type=template&id=cd27c5aa&scoped=true"
import script from "./AnnualReviewDetail.vue?vue&type=script&lang=js"
export * from "./AnnualReviewDetail.vue?vue&type=script&lang=js"
import style0 from "./AnnualReviewDetail.vue?vue&type=style&index=0&id=cd27c5aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd27c5aa",
  null
  
)

export default component.exports